import { render, staticRenderFns } from "./sales_details.vue?vue&type=template&id=e7f4f0f0&scoped=true"
import script from "./sales_details.vue?vue&type=script&lang=js"
export * from "./sales_details.vue?vue&type=script&lang=js"
import style0 from "./sales_details.vue?vue&type=style&index=0&id=e7f4f0f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f4f0f0",
  null
  
)

export default component.exports